import { render, staticRenderFns } from "./review-email-apendix.vue?vue&type=template&id=5e2c51ae&scoped=true"
import script from "./review-email-apendix.vue?vue&type=script&lang=js"
export * from "./review-email-apendix.vue?vue&type=script&lang=js"
import style0 from "./review-email-apendix.vue?vue&type=style&index=0&id=5e2c51ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c51ae",
  null
  
)

export default component.exports